import React from 'react';
import { Cell } from 'react-table';

const amountFormatter = (cell: Cell): JSX.Element => {
  const row = cell.row.values;
  const isNegative: boolean = row.userAddress && row.source === row.userAddress;

  return isNegative ? <span>{`-${cell.value}`}</span> : <span>{cell.value}</span>;
};

export default amountFormatter;
